import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { StructureTotemListProvider, WebSocketService } from 'cw-backend';
import { Subject, takeUntil } from 'rxjs';
import { TotemControlComponent } from '../../totem-control.component';

@Component({
  selector: 'cwg-totem-notify',
  templateUrl: './totem-notify.component.html',
  styleUrls: ['./totem-notify.component.scss']
})
export class TotemNotifyComponent implements OnInit, OnDestroy {


  quantityPassword: number;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private _bottomSheet: MatBottomSheet,
    private structureTotemListProvider: StructureTotemListProvider,
    private websocket: WebSocketService,
  ) {

  }

  ngOnInit() {

    this.getQuantityPassword();
    this.subscribeTotemQuantity();
    this.subscribeTotemQuantityChange();
  }

  ngOnDestroy(): void {
    this.websocket.unsubscribeTotemQuantity();
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  subscribeTotemQuantity() {
    this.websocket.subscribeTotemQuantity();
  }

  subscribeTotemQuantityChange() {
    this.websocket.totemQuantityReceived
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((message: any) => {
        this.quantityPassword = message?.body ? message.body : 0;

      });
  }

  openBottomSheet(): void {
    this._bottomSheet.open(TotemControlComponent, {
    });
  }

  getQuantityPassword() {
    this.structureTotemListProvider.getQuantityPassword().then((res: any) => {
      this.quantityPassword = res.body.data;
    }).catch((err: any) => {
      console.log(err);
    });
  }

}
